// extracted by mini-css-extract-plugin
export default {"container":"xOYDAobC7yj_PnNsMMCM","image":"NTPAw8kkHYe44mD9_McH"};